import { ButtonProps } from "antd";
import { StyleButton } from "./styled";
interface IProps extends ButtonProps {
  extendProps?: {
    type: string;
  };
}
const ButtonAction = (props: IProps) => {
  return <StyleButton {...props} icon={props.icon} />;
};
export default ButtonAction;
